import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import CommonHeader from './CommonHeader';
import { message } from 'antd';
import styles from './LoginPage.module.scss';
import { userLoginTrack } from '../utils/mixpanel';

const LoginPage: React.FC = () => {
  const { loginWithRedirect, isAuthenticated, user, getAccessTokenSilently, isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const tokenProcessing = useRef(false);
  const loginStarted = useRef(false);

  useEffect(() => {

    // If Auth0 is still loading, do nothing
    if (isLoading) {
      console.log('LoginPage: Auth0 loading...');
      return;
    }

    // If there's an Auth0 error, show it
    if (error) {
      console.error('LoginPage: Auth0 error:', error);
      message.error(`Auth0 Error: ${error.message}`);
      return;
    }

    // If user is authenticated, store token and navigate
    if (isAuthenticated && user && !tokenProcessing.current) {
      tokenProcessing.current = true;

      getAccessTokenSilently()
        .then((token) => {

          // Store token and user
          localStorage.setItem('authToken', token);
          
          const userDetails = {
            sub: user.sub,
            email: user.email,
            name: user.name,
            nickname: user.nickname,
            picture: user.picture,
            updated_at: user.updated_at,
            ...user,
          };
          localStorage.setItem('authUser', JSON.stringify(userDetails));
          
          localStorage.setItem('authTokenTimestamp', new Date().getTime().toString());
          userLoginTrack({
            id: user.org_id,
            email: user.email,
            name: user.name,
            userName: user.nickname
          });
          

          message.success('Login successful');

          // Navigate to dashboard
          navigate('/dashboard', { replace: true });
        })
        .catch((error) => {
          console.error('LoginPage: Failed to get token:', error);
          message.error(`Failed to get access token: ${error.message}`);
          tokenProcessing.current = false;
          loginStarted.current = false;
        });
    }
    // If not authenticated and we haven't started login, start Auth0 login flow
    else if (!isAuthenticated && !loginStarted.current && !isLoading) {
      loginStarted.current = true;

      loginWithRedirect({
        appState: { returnTo: '/dashboard' },
      }).catch((error) => {
        console.error('LoginPage: Auth0 login error:', error);
        message.error('Login failed');
        loginStarted.current = false;
      });
    }
  }, [isAuthenticated, user, isLoading, getAccessTokenSilently, navigate, loginWithRedirect, error]);

  return (
    <div className={styles.loginContainer}>
      <CommonHeader />
      <main className={styles.loginMain}>
        <div className={styles.loginFormContainer}>
          <h1 className={styles.loginTitle}>Seller Login</h1>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Redirecting to Auth0...</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
